<script setup>
  import UiTableAction from '@/components/ui/UiTableAction.vue';
  import AcPopover from '@/components/Popover/Popover.vue';

  const props = defineProps({
    tooltipContent: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
    row: {
      type: Object,
      default: () => {},
    },
    colorPreset: {
      type: String,
      default: 'green',
      validator: (prop) => ['green', 'red', 'orange', 'info'].includes(prop),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    wrapperClass: {
      type: String,
      default: null,
    },
    width: {
      type: Number,
      default: 200,
    },
    message: {
      type: String,
      default: '',
    },
    buttons: {
      type: Array,
      default: null,
    },
  });
</script>

<template>
  <AcPopover
    class="ui-table-popover-action"
    :width="width" 
    :message="message"
    :buttons="buttons"
    :disabled="disabled"
    :persistent="false"
    :wrapper-class="wrapperClass"
  >
    <UiTableAction
      wrapper-class="ui-table-popover-action__reference"
      :tooltip-content="tooltipContent"
      :icon-class="iconClass"
      :color-preset="colorPreset"
      :row="row"
      :disabled="disabled"
      :is-mobile="isMobile"
    />
  </AcPopover>
</template>

<style lang="scss">
  .ui-table-popover-action {
    &__reference {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>